/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_View_My_ToolsInputs */

const en_directory_submit_view_my_tools = /** @type {(inputs: Directory_Submit_View_My_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View my tools`)
};

const zh_directory_submit_view_my_tools = /** @type {(inputs: Directory_Submit_View_My_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看我的工具`)
};

/**
* | output |
* | --- |
* | "View my tools" |
*
* @param {Directory_Submit_View_My_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_view_my_tools = /** @type {((inputs?: Directory_Submit_View_My_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_View_My_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_view_my_tools(inputs)
	return zh_directory_submit_view_my_tools(inputs)
});
export { directory_submit_view_my_tools as "directory.submit.view_my_tools" }